var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{staticClass:"btn",class:[_vm.data.staticClass, _vm.data.class, {
                    'btn-lg': _vm.props.size === 'lg',
                    'btn-sm': _vm.props.size === 'sm',
                    'btn-xs': _vm.props.size === 'xs',
                }, {'loading-btn': _vm.props.loading}],attrs:{"disabled":_vm.props.disabled || _vm.props.loading,"readonly":_vm.props.readonly},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }